<template>
  <button type="button"
          :class="classString"
          @click="goToUpgradePage"
          class="relative block rounded-lg border-2 border-dashed border-gray-300 p-2 text-center hover:border-gray-400
  focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
  >
    <span class="my-2 block text-sm font-medium text-gray-900">Feature available in {{ featureAvailableIn }}</span>
  </button>
</template>

<script>
import {SonicuCoreMixin} from '@/mixins/SonicuCoreMixin'

export default {
  name: "FeatureGate",
  mixins: [SonicuCoreMixin],
  props: {
    width: {
      type: String,
      default: 'w-48'
    },
    featureAvailableIn: {
      type: String,
      default: 'a higher version of SoniCloud'
    },
    featureName: {
      type: String,
      default: 'unknown',
      required: true
    }
  },
  computed: {
    classString(){
      return this.width;
    },
    onClickUrl(){
      return this.company.buildCompanyRoute('upgrade') + '?feature=' + this.featureName
    }
  },
  methods:{
    goToUpgradePage(){
      window.open(this.onClickUrl, '_blank').focus();
    }
  }
}
</script>

<style scoped>

</style>